import type { FC } from 'react';

const PETAL_COUNT = 15;
const petals = Array.from({ length: PETAL_COUNT }, (_, i) => i);

export const SakuraPetals: FC = () => (
	<div className='sakura-container' aria-hidden='true'>
		{petals.map(i => (
			<div key={i} className='sakura-petal' />
		))}
	</div>
);
